import React, { useEffect, useState } from "react"
import { useParams, useNavigate, Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
   getStorage,
   ref,
   uploadBytesResumable,
   getDownloadURL,
} from "firebase/storage"
import app from "../../firebase"
import {
   CalendarToday,
   LocationSearching,
   MailOutline,
   PermIdentity,
   PhoneAndroid,
   Publish,
} from "@material-ui/icons"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import Checkbox from "../../components/Checkbox/Checkbox"
import Orders from "../../components/Orders/Orders"
import Favorites from "../../components/Favorites/Favorites"
import Address from "../../components/Address/Address"
// Data
import { updateUser } from "../../redux/apiCalls"
// Styles
import NoAvatar from "../../images/no_avatar.jpg"
import {
   Container,
   Wrapper,
   Main,
   StyledButton,
   Title,
   TitleWrapper,
   Display,
   WideBox,
   DisplayTop,
   UserImage,
   DisplayBottom,
   DisplayInfo,
} from "./User.styles"
import {
   UserTitle,
   UserName,
   UserJob,
   UserDetailsTitle,
   UsersDetailsInfo,
   UserDetailsIcon,
   UserDetails,
   BoxTitle,
   FormItem,
} from "./User.styles"
import {
   StyledForm,
   StyledSelect,
   StyledOption,
   StyledLabel,
   StyledInput,
   Upload,
   UpdateImage,
   UploadIcon,
} from "./User.styles"
import {
   ButtonContainer,
   ButtonWrapper,
   Message,
   UserWrapper,
   DisplayLeft,
   DisplayRight,
} from "./User.styles"

const User = () => {
   const { userId } = useParams()
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")

   const user = useSelector((state) =>
      state.user.users.find((user) => user._id === userId)
   )
   const [userInputs, setUserInputs] = useState({})
   const [deliveryAddress, setDeliveryAddress] = useState(user.deliveryAddress)
   const [invoiceAddress, setInvoiceAddress] = useState(user.invoiceAddress)

   useEffect(() => {
      if (typeof user === "object" && user !== null) {
         const { password, ...userToUpdate } = user
         setUserInputs(userToUpdate)
      }
      setUserInputs((prev) => {
         return {
            ...prev,
            deliveryAddress: deliveryAddress,
            invoiceAddress: invoiceAddress,
         }
      })
   }, [user, deliveryAddress, invoiceAddress])

   const [isAdmin, setIsAdmin] = useState(user.isAdmin)
   const isAdminChange = () => {
      setUserInputs((prev) => {
         return { ...prev, isAdmin: !isAdmin }
      })
      setIsAdmin((current) => !current)
   }

   const [active, setActive] = useState(user.active)
   const activeChange = () => {
      setUserInputs((prev) => {
         return { ...prev, active: !active }
      })
      setActive((current) => !current)
   }

   const [emailing, setEmailing] = useState(user.emailing)
   const emailingChange = () => {
      setUserInputs((prev) => {
         return { ...prev, emailing: !emailing }
      })
      setEmailing((current) => !current)
   }

   const [sms, setSms] = useState(user.sms)
   const smsChange = () => {
      setUserInputs((prev) => {
         return { ...prev, sms: !sms }
      })
      setSms((current) => !current)
   }

   const handleChange = (e) => {
      setUserInputs((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleImage = (e) => {
      const storage = getStorage(app)
      const fileName = "user_" + userInputs.username
      const storageRef = ref(storage, fileName)
      const uploadTask = uploadBytesResumable(storageRef, e.target.files[0])

      uploadTask.on(
         "state_changed",
         (snapshot) => {
            const progress =
               (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            console.log("Upload is " + progress + "% done")
            switch (snapshot.state) {
               case "paused":
                  console.log("Upload is paused")
                  break
               case "running":
                  console.log("Upload is running")
                  break
               default:
            }
         },
         (error) => {
            console.log(error)
         },
         () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
               console.log("File available at", downloadURL)
               setUserInputs((prev) => {
                  return { ...prev, img: downloadURL }
               })
            })
         }
      )
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const res = await updateUser(userId, userInputs, dispatch)
      if (res === "success") {
         navigate("/users")
      } else {
         setErrorMessage(JSON.stringify(res))
      }
   }

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Edit User</Title>
                  <Link to="/newUser">
                     <StyledButton>Create</StyledButton>
                  </Link>
               </TitleWrapper>
               <UserWrapper>
                  <Display>
                     <DisplayLeft>
                        <DisplayTop>
                           <UserImage src={user.img || NoAvatar} />
                           <UserTitle>
                              <UserName>
                                 {user.firstName} {user.lastName}
                              </UserName>
                              <UserJob>{user.type}</UserJob>
                           </UserTitle>
                        </DisplayTop>
                        <DisplayInfo>
                           <DisplayBottom>
                              <UserDetailsTitle>
                                 Account Details
                              </UserDetailsTitle>
                              <UserDetails>
                                 <UserDetailsIcon>
                                    <PermIdentity />
                                 </UserDetailsIcon>
                                 <UsersDetailsInfo>
                                    {user.username}
                                 </UsersDetailsInfo>
                              </UserDetails>
                              <UserDetails>
                                 <UserDetailsIcon>
                                    <CalendarToday />
                                 </UserDetailsIcon>
                                 <UsersDetailsInfo>
                                    {new Date(
                                       user.createdAt
                                    ).toLocaleDateString()}
                                 </UsersDetailsInfo>
                              </UserDetails>
                           </DisplayBottom>
                           <DisplayBottom>
                              <UserDetailsTitle>
                                 Contact Details
                              </UserDetailsTitle>
                              <UserDetails>
                                 <UserDetailsIcon>
                                    <PhoneAndroid />
                                 </UserDetailsIcon>
                                 <UsersDetailsInfo>
                                    {user.phone}
                                 </UsersDetailsInfo>
                              </UserDetails>
                              <UserDetails>
                                 <UserDetailsIcon>
                                    <MailOutline />
                                 </UserDetailsIcon>
                                 <UsersDetailsInfo>
                                    {user.email}
                                 </UsersDetailsInfo>
                              </UserDetails>
                              <UserDetails>
                                 <UserDetailsIcon>
                                    <LocationSearching />
                                 </UserDetailsIcon>
                                 <UsersDetailsInfo>
                                    {user.deliveryAddress?.city},{" "}
                                    {user.deliveryAddress?.country}
                                 </UsersDetailsInfo>
                              </UserDetails>
                           </DisplayBottom>
                        </DisplayInfo>
                     </DisplayLeft>
                     <DisplayRight>
                        <BoxTitle>Orders</BoxTitle>
                        <Orders userId={user._id} />
                     </DisplayRight>
                  </Display>
                  <WideBox>
                     <BoxTitle>Favorites</BoxTitle>
                     <Favorites products={user.favoriteProducts} />
                  </WideBox>
                  <WideBox>
                     <BoxTitle>Edit</BoxTitle>
                     <StyledForm>
                        <FormItem>
                           <StyledLabel>Username</StyledLabel>
                           <StyledInput
                              type="text"
                              name="username"
                              defaultValue={user.username}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>First Name</StyledLabel>
                           <StyledInput
                              type="text"
                              name="firstName"
                              defaultValue={user.firstName}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Last Name</StyledLabel>
                           <StyledInput
                              type="text"
                              name="lastName"
                              defaultValue={user.lastName}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Type</StyledLabel>
                           <StyledSelect
                              name="type"
                              id="type"
                              defaultValue={user.type}
                              onChange={handleChange}
                           >
                              <StyledOption value="public">Public</StyledOption>
                              <StyledOption value="distributor">
                                 Distributor
                              </StyledOption>
                              <StyledOption value="optician">
                                 Optician
                              </StyledOption>
                           </StyledSelect>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Email</StyledLabel>
                           <StyledInput
                              type="text"
                              name="email"
                              defaultValue={user.email}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Password</StyledLabel>
                           <StyledInput
                              type="password"
                              name="password"
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={isAdmin}
                                 onChange={isAdminChange}
                              />
                              Admin
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={active}
                                 onChange={activeChange}
                              />
                              Active
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Customer number</StyledLabel>
                           <StyledInput
                              type="text"
                              name="customerCode"
                              defaultValue={user.customerCode}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Discount (%)</StyledLabel>
                           <StyledInput
                              type="number"
                              name="discount"
                              defaultValue={user.discount}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox
                                 checked={emailing}
                                 onChange={emailingChange}
                              />
                              Emailing
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>
                              <Checkbox checked={sms} onChange={smsChange} />
                              SMS
                           </StyledLabel>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Language</StyledLabel>
                           <StyledSelect
                              name="language"
                              id="language"
                              defaultValue={user.language}
                              onChange={handleChange}
                           >
                              <StyledOption value="en">English</StyledOption>
                              <StyledOption value="fr">French</StyledOption>
                           </StyledSelect>
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Phone</StyledLabel>
                           <StyledInput
                              type="text"
                              name="phone"
                              defaultValue={user.phone}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Company name</StyledLabel>
                           <StyledInput
                              type="text"
                              name="companyName"
                              defaultValue={user.companyName}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <Address
                           role="delivery"
                           address={deliveryAddress}
                           setAddress={setDeliveryAddress}
                        />
                        <Address
                           role="invoice"
                           address={invoiceAddress}
                           setAddress={setInvoiceAddress}
                        />
                        <Upload>
                           <UpdateImage src={userInputs.img || NoAvatar} />
                           <StyledLabel htmlFor={"files"}>
                              <UploadIcon>
                                 <Publish />
                              </UploadIcon>
                           </StyledLabel>
                           <StyledInput
                              type="file"
                              id="files"
                              name="files"
                              style={{ display: "none" }}
                              multiple
                              onChange={handleImage}
                           />
                        </Upload>
                     </StyledForm>
                  </WideBox>
               </UserWrapper>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Update</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default User
